// Servicios mockeados que simulan la API REST de Defontana
// Estos datos serán reemplazados por integraciones reales

export interface VentaMensual {
  mes: string;
  ventas: number;
  pedidos: number;
  clientes: number;
}

export interface Cliente {
  id: string;
  nombre: string;
  rut: string;
  email: string;
  telefono: string;
  direccion: string;
  tipo: 'industrial' | 'comercial' | 'particular';
  fechaRegistro: string;
  totalCompras: number;
}

export interface Producto {
  id: string;
  nombre: string;
  categoria: string;
  precio: number;
  stock: number;
  unidad: string;
  descripcion: string;
  imagen?: string;
  activo: boolean;
}

export interface Pedido {
  id: string;
  cliente: string;
  fecha: string;
  estado: 'pendiente' | 'confirmado' | 'en_proceso' | 'completado' | 'cancelado';
  total: number;
  items: PedidoItem[];
  tipo: 'remate' | 'venta_directa' | 'contrato';
}

export interface PedidoItem {
  producto: string;
  cantidad: number;
  precio: number;
  subtotal: number;
}

export interface Remate {
  id: string;
  titulo: string;
  fechaInicio: string;
  fechaFin: string;
  estado: 'activo' | 'proximo' | 'finalizado';
  totalRecaudado: number;
  participantes: number;
  ofertas: number;
  lotes: LoteRemate[];
}

export interface LoteRemate {
  id: string;
  producto: string;
  cantidad: number;
  precioBase: number;
  precioActual: number;
  estado: 'disponible' | 'vendido' | 'sin_ofertas';
  ofertas: OfertaRemate[];
}

export interface OfertaRemate {
  id: string;
  cliente: string;
  monto: number;
  fecha: string;
  estado: 'activa' | 'ganadora' | 'perdedora';
}

export interface Gasto {
  id: string;
  descripcion: string;
  monto: number;
  categoria: string;
  fecha: string;
  trabajador: string;
  comprobante?: string;
  estado: 'pendiente' | 'aprobado' | 'rechazado';
}

export interface Reporte {
  id: string;
  titulo: string;
  tipo: 'ventas' | 'inventario' | 'financiero' | 'logistica';
  fechaGeneracion: string;
  periodo: string;
  datos: any;
}

export interface MensajeInbox {
  id: string;
  titulo: string;
  mensaje: string;
  tipo: 'info' | 'warning' | 'error' | 'success';
  fecha: string;
  leido: boolean;
}

// Datos mockeados
const ventasMensuales: VentaMensual[] = [
  { mes: 'Ene', ventas: 125000, pedidos: 45, clientes: 12 },
  { mes: 'Feb', ventas: 142000, pedidos: 52, clientes: 15 },
  { mes: 'Mar', ventas: 138000, pedidos: 48, clientes: 18 },
  { mes: 'Abr', ventas: 165000, pedidos: 61, clientes: 22 },
  { mes: 'May', ventas: 158000, pedidos: 58, clientes: 20 },
  { mes: 'Jun', ventas: 172000, pedidos: 65, clientes: 25 },
  { mes: 'Jul', ventas: 189000, pedidos: 72, clientes: 28 },
  { mes: 'Ago', ventas: 195000, pedidos: 78, clientes: 30 },
  { mes: 'Sep', ventas: 182000, pedidos: 69, clientes: 27 },
  { mes: 'Oct', ventas: 201000, pedidos: 85, clientes: 32 },
  { mes: 'Nov', ventas: 218000, pedidos: 92, clientes: 35 },
  { mes: 'Dic', ventas: 235000, pedidos: 98, clientes: 38 }
];

const clientes: Cliente[] = [
  {
    id: '1',
    nombre: 'Minera Los Andes S.A.',
    rut: '12.345.678-9',
    email: 'contacto@mineralosandes.cl',
    telefono: '+56 9 1234 5678',
    direccion: 'Av. Minera 123, Antofagasta',
    tipo: 'industrial',
    fechaRegistro: '2023-01-15',
    totalCompras: 1250000
  },
  {
    id: '2',
    nombre: 'Comercializadora Norte Ltda.',
    rut: '98.765.432-1',
    email: 'ventas@comercialnorte.cl',
    telefono: '+56 9 8765 4321',
    direccion: 'Calle Comercial 456, Santiago',
    tipo: 'comercial',
    fechaRegistro: '2023-02-20',
    totalCompras: 890000
  },
  {
    id: '3',
    nombre: 'Juan Pérez',
    rut: '11.222.333-4',
    email: 'juan.perez@email.com',
    telefono: '+56 9 1111 2222',
    direccion: 'Calle Particular 789, Valparaíso',
    tipo: 'particular',
    fechaRegistro: '2023-03-10',
    totalCompras: 45000
  }
];

const productos: Producto[] = [
  {
    id: '1',
    nombre: 'Cobre Refinado 99.9%',
    categoria: 'Metales',
    precio: 8500,
    stock: 2500,
    unidad: 'kg',
    descripcion: 'Cobre refinado de alta pureza para exportación',
    activo: true
  },
  {
    id: '2',
    nombre: 'Oro en Lingotes',
    categoria: 'Metales Preciosos',
    precio: 65000,
    stock: 150,
    unidad: 'g',
    descripcion: 'Oro refinado en lingotes de 1kg',
    activo: true
  },
  {
    id: '3',
    nombre: 'Plata Granulada',
    categoria: 'Metales Preciosos',
    precio: 850,
    stock: 5000,
    unidad: 'kg',
    descripcion: 'Plata granulada para procesos industriales',
    activo: true
  },
  {
    id: '4',
    nombre: 'Concentrado de Cobre',
    categoria: 'Concentrados',
    precio: 3200,
    stock: 10000,
    unidad: 'ton',
    descripcion: 'Concentrado de cobre con 25% de pureza',
    activo: true
  }
];

const pedidos: Pedido[] = [
  {
    id: 'PED-001',
    cliente: 'Minera Los Andes S.A.',
    fecha: '2024-01-15',
    estado: 'completado',
    total: 425000,
    tipo: 'contrato',
    items: [
      { producto: 'Cobre Refinado 99.9%', cantidad: 50, precio: 8500, subtotal: 425000 }
    ]
  },
  {
    id: 'PED-002',
    cliente: 'Comercializadora Norte Ltda.',
    fecha: '2024-01-16',
    estado: 'en_proceso',
    total: 97500,
    tipo: 'venta_directa',
    items: [
      { producto: 'Oro en Lingotes', cantidad: 1.5, precio: 65000, subtotal: 97500 }
    ]
  },
  {
    id: 'PED-003',
    cliente: 'Juan Pérez',
    fecha: '2024-01-17',
    estado: 'pendiente',
    total: 4250,
    tipo: 'remate',
    items: [
      { producto: 'Plata Granulada', cantidad: 5, precio: 850, subtotal: 4250 }
    ]
  }
];

const remates: Remate[] = [
  {
    id: 'REM-001',
    titulo: 'Remate de Metales Preciosos - Enero 2024',
    fechaInicio: '2024-01-20',
    fechaFin: '2024-01-25',
    estado: 'activo',
    totalRecaudado: 1250000,
    participantes: 15,
    ofertas: 45,
    lotes: [
      {
        id: 'LOTE-001',
        producto: 'Oro en Lingotes',
        cantidad: 2,
        precioBase: 60000,
        precioActual: 68000,
        estado: 'vendido',
        ofertas: [
          { id: 'OF-001', cliente: 'Minera Los Andes S.A.', monto: 68000, fecha: '2024-01-22', estado: 'ganadora' }
        ]
      }
    ]
  }
];

const gastos: Gasto[] = [
  {
    id: 'GAS-001',
    descripcion: 'Combustible para vehículos de transporte',
    monto: 150000,
    categoria: 'Combustible',
    fecha: '2024-01-15',
    trabajador: 'Carlos Mendoza',
    estado: 'aprobado'
  },
  {
    id: 'GAS-002',
    descripcion: 'Colación para personal de campo',
    monto: 45000,
    categoria: 'Colación',
    fecha: '2024-01-16',
    trabajador: 'María González',
    estado: 'pendiente'
  },
  {
    id: 'GAS-003',
    descripcion: 'Materiales de oficina',
    monto: 25000,
    categoria: 'Materiales',
    fecha: '2024-01-17',
    trabajador: 'Roberto Silva',
    estado: 'aprobado'
  }
];

const mensajesInbox: MensajeInbox[] = [
  {
    id: 'MSG-001',
    titulo: 'Nuevo pedido recibido',
    mensaje: 'Se ha recibido un nuevo pedido de Minera Los Andes S.A. por $425,000',
    tipo: 'info',
    fecha: '2024-01-15T10:30:00Z',
    leido: false
  },
  {
    id: 'MSG-002',
    titulo: 'Stock bajo de Cobre Refinado',
    mensaje: 'El stock de Cobre Refinado 99.9% está por debajo del mínimo recomendado',
    tipo: 'warning',
    fecha: '2024-01-16T14:20:00Z',
    leido: false
  },
  {
    id: 'MSG-003',
    titulo: 'Remate finalizado exitosamente',
    mensaje: 'El remate de metales preciosos ha finalizado con $1,250,000 recaudados',
    tipo: 'success',
    fecha: '2024-01-17T16:45:00Z',
    leido: true
  }
];

// Funciones de la API simulada
export const defontanaApi = {
  // Dashboard
  getVentasMensuales: async (): Promise<VentaMensual[]> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return ventasMensuales;
  },

  getIndicadoresGenerales: async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      ventasTotales: 235000,
      pedidosCerrados: 98,
      clientesActivos: 38,
      stockTotal: 17500,
      gastosMensuales: 220000
    };
  },

  getProductosMasVendidos: async (periodo: 'semana' | 'mes' | 'año' = 'mes') => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return [
      { producto: 'Cobre Refinado 99.9%', cantidad: 150, ventas: 1275000 },
      { producto: 'Oro en Lingotes', cantidad: 25, ventas: 1625000 },
      { producto: 'Plata Granulada', cantidad: 200, ventas: 170000 },
      { producto: 'Concentrado de Cobre', cantidad: 50, ventas: 160000 }
    ];
  },

  getOrdenesPorCanal: async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      { canal: 'Remates Online', cantidad: 45, porcentaje: 35 },
      { canal: 'Ventas Mineras', cantidad: 60, porcentaje: 47 },
      { canal: 'Tienda Física', cantidad: 23, porcentaje: 18 }
    ];
  },

  getOrdenesRecientes: async (limite: number = 10) => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return pedidos.slice(0, limite);
  },

  // Clientes
  getClientes: async (): Promise<Cliente[]> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return clientes;
  },

  getClienteById: async (id: string): Promise<Cliente | null> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return clientes.find(c => c.id === id) || null;
  },

  // Productos
  getProductos: async (): Promise<Producto[]> => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return productos;
  },

  getProductoById: async (id: string): Promise<Producto | null> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return productos.find(p => p.id === id) || null;
  },

  createProducto: async (nuevo: Omit<Producto, 'id' | 'activo'> & { activo?: boolean }): Promise<Producto> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    const id = (productos.length + 1).toString();
    const producto: Producto = {
      id,
      nombre: nuevo.nombre,
      categoria: nuevo.categoria,
      precio: nuevo.precio,
      stock: nuevo.stock,
      unidad: nuevo.unidad,
      descripcion: nuevo.descripcion,
      activo: nuevo.activo ?? true
    };
    productos.unshift(producto);
    return producto;
  },

  // Pedidos
  getPedidos: async (): Promise<Pedido[]> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return pedidos;
  },

  getPedidoById: async (id: string): Promise<Pedido | null> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return pedidos.find(p => p.id === id) || null;
  },

  // Remates
  getRemates: async (): Promise<Remate[]> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return remates;
  },

  getRemateById: async (id: string): Promise<Remate | null> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return remates.find(r => r.id === id) || null;
  },

  // Gastos
  getGastos: async (): Promise<Gasto[]> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return gastos;
  },

  getGastosPorCategoria: async () => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return [
      { categoria: 'Combustible', total: 150000, cantidad: 5 },
      { categoria: 'Colación', total: 45000, cantidad: 12 },
      { categoria: 'Materiales', total: 25000, cantidad: 8 },
      { categoria: 'Peajes', total: 35000, cantidad: 15 }
    ];
  },

  // Inbox
  getMensajesInbox: async (): Promise<MensajeInbox[]> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return mensajesInbox;
  },

  marcarMensajeComoLeido: async (id: string): Promise<void> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const mensaje = mensajesInbox.find(m => m.id === id);
    if (mensaje) {
      mensaje.leido = true;
    }
  },

  // Reportes
  getReportes: async (): Promise<Reporte[]> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return [
      {
        id: 'REP-001',
        titulo: 'Reporte de Ventas Mensual',
        tipo: 'ventas',
        fechaGeneracion: '2024-01-01',
        periodo: 'Enero 2024',
        datos: { ventas: 235000, pedidos: 98 }
      }
    ];
  }
};
